import { useNavigate } from 'react-router-dom';
import { useCreateConcert } from '@/hooks';
import { CreateConcertRequest } from '@/types/model';
import ConcertForm from '@/components/forms/ConcertForm';
import Button from '@/components/ui/Button.tsx';
import toast from 'react-hot-toast';

const CreateConcert = () => {
  const navigate = useNavigate();
  const createConcertMutation = useCreateConcert();

  const handleSuccess = async (data: CreateConcertRequest) => {
    try {
      await createConcertMutation.mutateAsync(data);
      toast.success('Concert created successfully');
      navigate('/content/concerts');
    } catch (error) {
      console.error('Create error:', error);
      toast.error(error instanceof Error ? error.message : 'Unexpected error');
      throw error; // Re-throw to let form handle the error
    }
  };

  const handleCancel = () => {
    navigate('/content/concerts');
  };

  return (
    <div className="min-h-screen bg-gray-50 py-4">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Button
          onClick={handleCancel}
          variant="link"
        >
          ← Volver a la lista
        </Button>
        <ConcertForm
          onSuccess={handleSuccess}
          onCancel={handleCancel}
          isSubmitting={createConcertMutation.isPending}
        />
      </div>
    </div>
  );
};

export default CreateConcert;
